import { render, staticRenderFns } from "./GroupFeaturedMemberEdit.vue?vue&type=template&id=7a6230c0&"
import script from "./GroupFeaturedMemberEdit.vue?vue&type=script&lang=js&"
export * from "./GroupFeaturedMemberEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupFeaturedMemberEdit.vue?vue&type=style&index=0&id=7a6230c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports